// Port of api/fuel/app/classes/filter/search/games/filters/query/play/soloplayed.php
export default {
	name: 'play.soloplayed',
	priority: 82,
	require: function(config, filter) {
		return filter.soloplayed === 1
	},
	run: function(config, filter, data, query) {
		query.where('p.play_players', '=', 1)
	}
}
